import { Fragment } from 'react'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Trans } from '@lingui/macro'
import Button from 'Root/App/Button'
import TopContent from 'Root/Pages/Content/Component/TopContent'

library.add(faArrowRight)

const DefaultStatus = ({ content, setIsCompleted }) => {
  return (
    <Fragment>
      <TopContent content={content} setIsCompleted={setIsCompleted} />
      {content.__typename === 'LinkContent' && (
        <Button anchor size="L" target="_blank" to={content.url}>
          <div className="flex flex-row gap-2">
            <div>
              <Trans>Vai al link</Trans>
            </div>
            <div>
              <FontAwesomeIcon icon={['fas', 'arrow-right']} />
            </div>
          </div>
        </Button>
      )}
    </Fragment>
  )
}

export default DefaultStatus
